import { Dispatch } from 'redux'

import { getDataRuns, startDataRunJob } from 'redux/api/internal/DataRuns'
import { ApplicationState } from 'redux/Stores/types'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

export function tryGetDataRuns(customerId?: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.get({ customerId }))

    getDataRuns(customerId)
      .then((response) => {
        dispatch(actions.getSuccess({ data: response.data.data, customerId }))
      })
      .catch(() => {
        dispatch(actions.getFailed({ customerId }))
      })
  }
}

export function tryStartDataRunJob(jobName: string) {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    dispatch(actions.startJob({ jobName }))

    startDataRunJob(jobName)
      .then(() => {
        dispatch(actions.startJobSuccess({ jobName }))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        const { requestedCustomerId } = getState().InternalDataRunsStore

        tryGetDataRuns(requestedCustomerId ?? undefined)(dispatch)
      })
      .catch(() => {
        dispatch(actions.startJobFailed({ jobName }))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export const useDataRunsActions = () => {
  return {
    tryGetDataRuns: useThunkActions(tryGetDataRuns),
    tryStartDataRunJob: useThunkActions(tryStartDataRunJob)
  }
}
